import { render, staticRenderFns } from "./sys-main.vue?vue&type=template&id=a5e4946c&scoped=true&"
import script from "./sys-main.vue?vue&type=script&lang=js&"
export * from "./sys-main.vue?vue&type=script&lang=js&"
import style0 from "./sys-main.vue?vue&type=style&index=0&id=a5e4946c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5e4946c",
  null
  
)

export default component.exports